export default __webpack_public_path__ + "static/media/IMAGEM DOS PRODUTOS - SAMSUNG.5a2d7847.png";